import axios from 'axios';

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // 401 Unauthorized - likely an expired JWT token
      localStorage.removeItem("authorization");
      
      // We can use window.location.href to force a hard redirect to the root login
      // A hard reload will clear React state and re-initialize the app routes
      alert("Your session has expired. Please log in again to continue.");
      window.location.href = '/'; 
    }
    return Promise.reject(error);
  }
);

export default axios;
